import _Vue from 'vue'
import axios, { AxiosRequestConfig, AxiosResponse, AxiosInstance } from 'axios'

/* main config */
const conf: AxiosRequestConfig = {
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true
}

const HTTP: AxiosInstance = axios.create(conf)
const HTTP_AUTH_CHECK: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_AUTH_URL
})

export interface Http {
  registerRequest(language: string, msisdn: string, owner: string): Promise<any>
  confirmRegister(msisdn: string, otp: string): Promise<any>

  unregisterRequest(
    language: string,
    msisdn: string,
    owner: string
  ): Promise<any>
  confirmUnregister(msisdn: string, otp: string): Promise<any>

  listRequest(language: string, msisdn: string): Promise<any>
  confirmList(msisdn: string, otp: string): Promise<any>

  reregisterRequest(
    language: string,
    msisdn: string,
    owner: string,
    prevMsisdn: string,
    prevType: number | null,
    prevOwner: string,
    type: number | null
  ): Promise<any>
  confirmReregister(msisdn: string, otp: string): Promise<any>

  checkDevice(imei: string): Promise<boolean>

  getFaqArticles(categoryId: number): Promise<any>

  getAuthNumber(): Promise<any>
}

// noinspection JSUnusedGlobalSymbols,SpellCheckingInspection
const methods = {
  registerRequest(language: string, msisdn: string, owner: string) {
    // noinspection SpellCheckingInspection
    return HTTP.post('/drs/imei/register/request', {
      language,
      msisdn,
      owner
    })
  },
  confirmRegister(msisdn: string, otp: string) {
    // noinspection SpellCheckingInspection
    return HTTP.post('/drs/imei/register/confirm', {
      msisdn,
      otp
    })
  },

  unregisterRequest(language: string, msisdn: string, owner: string) {
    // noinspection SpellCheckingInspection
    return HTTP.post('/drs/imei/unregister/request', {
      language,
      msisdn,
      owner
    })
  },
  confirmUnregister(msisdn: string, otp: string) {
    // noinspection SpellCheckingInspection
    return HTTP.post('/drs/imei/unregister/confirm', {
      msisdn,
      otp
    })
  },

  listRequest(language: string, msisdn: string) {
    // noinspection SpellCheckingInspection
    return HTTP.post('/drs/imei/device-list/request', {
      language,
      msisdn
    })
  },
  confirmList(msisdn: string, otp: string) {
    // noinspection SpellCheckingInspection
    return HTTP.post('/drs/imei/device-list/confirm', {
      msisdn,
      otp
    })
  },

  reregisterRequest(
    language: string,
    msisdn: string,
    owner: string,
    prevMsisdn: string,
    prevType: number | null,
    prevOwner: string,
    type: number | null
  ) {
    // noinspection SpellCheckingInspection
    return HTTP.post('/drs/imei/change-owner/request', {
      language,
      msisdn,
      owner,
      prevMsisdn,
      prevType,
      prevOwner,
      type
    })
  },
  confirmReregister(msisdn: string, otp: string) {
    // noinspection SpellCheckingInspection
    return HTTP.post('/drs/imei/change-owner/confirm', {
      msisdn,
      otp
    })
  },

  checkDevice(imei: string) {
    return HTTP.get(`/drs/imei/check?imei=${imei}`)
  },

  getFaqArticles(categoryId: number) {
    return HTTP.get(`/faq/categories/${categoryId}/articles`)
  },

  getAuthNumber() {
    return HTTP_AUTH_CHECK.get('/auth/my-number')
  }
}

export default function http(Vue: typeof _Vue): void {
  // noinspection JSUnusedGlobalSymbols
  Vue.prototype.$http = methods
}
